import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "clock--circle",
  "use": "clock--circle-usage",
  "viewBox": "0 0 18.763 18.77",
  "content": "<symbol viewBox=\"0 0 18.763 18.77\" id=\"clock--circle\"><path d=\"M9.375 0a9.358 9.358 0 0 0-6.637 2.736c-3.651 3.645-3.651 9.614 0 13.261a9.274 9.274 0 0 0 6.624 2.773c2.4 0 4.8-.924 6.651-2.748a9.308 9.308 0 0 0 2.749-6.643A9.36 9.36 0 0 0 9.375 0zm5.212 14.598a7.37 7.37 0 0 1-5.225 2.154 7.373 7.373 0 0 1-5.225-2.154c-2.874-2.871-2.874-7.567 0-10.439 2.876-2.873 7.575-2.873 10.45 0a7.329 7.329 0 0 1 2.175 5.22 7.322 7.322 0 0 1-2.175 5.219zM9.613 9.379h3.999v1.998h-6V4.383h2.001v4.996z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/clock--circle.svg
// module id = 155
// module chunks = 0